module.exports = __webpack_public_path__ + "img/2_46.b5727187.png";